import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';
import { Grid, Button, Icon, Table, Header } from 'semantic-ui-react';
import i18next from 'i18next';
import SideEditor from '../../general/SideEditor';
import PermissionsEditor from './PermissionsEditor';
import { setEditedEntity, confirmDelete, fetchWorkerPermissions, deletePaymentPermissions } from '../../../actions';
import { formatPrice } from '../../../helpers/format';

class WorkerDetails extends Component {
    componentWillMount() {
        const { companyId, workerId } = this.props.match.params;

        this.props.fetchWorkerPermissions(companyId, workerId);
    }


    handleDelete(permission) {
        const { companyId, workerId } = this.props.match.params;

        this.props.confirmDelete(permission.label, () => this.props.deletePaymentPermissions(companyId, workerId, permission.id));
    }

    render() {
        const { companyId } = this.props.match.params;
        const { worker } = this.props;

        if (!worker) {
            return <Redirect to={`/company/${companyId}/workers`} />;
        }

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('grantPermission')}
                    visible={this.props.onEdit}
                    handleClose={() => this.props.setEditedEntity(null)}
                >
                    <PermissionsEditor company={this.props.company} worker={worker} />
                </SideEditor>

                <Grid stackable columns={2}>
                    <Grid.Column>
                        <Table celled padded>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>{i18next.t('name')}</Table.Cell>
                                    <Table.Cell>{worker.name}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{i18next.t('phone')}</Table.Cell>
                                    <Table.Cell>{worker.phone}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{i18next.t('cardNumber')}</Table.Cell>
                                    <Table.Cell>{worker.label}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{i18next.t('expenses')}</Table.Cell>
                                    <Table.Cell>{formatPrice(worker.usedAmount || 0, this.props.company.currencyCode)}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                    <Grid.Column>
                        <Button
                            content={i18next.t('grantPermission')}
                            icon='add'
                            onClick={() => this.props.setEditedEntity('paymentPermission')}
                            primary
                        />

                        <Table celled padded>
                            <Table.Header fullWidth>
                                <Table.Row>
                                    <Table.HeaderCell singleLine>{i18next.t('permissionReceiver')}</Table.HeaderCell>
                                    <Table.HeaderCell singleLine>{i18next.t('description')}</Table.HeaderCell>
                                    <Table.HeaderCell singleLine>{i18next.t('actions')}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {(worker.permissions || []).map((permission) => {
                                    return (
                                        <Table.Row key={permission.id}>
                                            <Table.Cell collapsing>{permission.label}</Table.Cell>
                                            <Table.Cell>
                                                <div>{i18next.t(permission.useOnce ? 'paymentPermission.useOnce' : 'paymentPermission.unlimitedUses')}</div>
                                                <div>{i18next.t(permission.budgetOnly ? 'paymentPermission.budgetOnly' : 'paymentPermission.budgetAndCredit')}</div>
                                            </Table.Cell>
                                            <Table.Cell collapsing>
                                                <Button circular size='tiny' icon='trash' negative onClick={() => this.handleDelete(permission)} />
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                </Grid>
            </div >
        );

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('addWorker')}
                    visible={this.props.onEdit}
                    handleClose={() => this.props.setEditedEntity(null)}
                >
                    <PermissionsEditor companyId={companyId} />
                </SideEditor>

                <Button
                    content={i18next.t('grantPermission')}
                    icon='add'
                    onClick={() => this.props.setEditedEntity('paymentPermission')}
                    primary
                />

                <Header>{i18next.t('permissionsGranted')}</Header>

                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell singleLine>{i18next.t('permissionReceiver')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('description')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('actions')}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {(this.props.worker.permissions || []).map((permission) => {
                            return (
                                <Table.Row key={permission.id}>
                                    <Table.Cell collapsing>{permission.label}</Table.Cell>
                                    <Table.Cell>
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        <Button circular size='tiny' icon='trash' negative onClick={() => this.handleDelete(permission)} />
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

WorkerDetails.propTypes = {
    company: PropTypes.object,
    match: PropTypes.object,
    worker: PropTypes.object,
    workers: PropTypes.array,
    confirmDelete: PropTypes.func,
    setEditedEntity: PropTypes.func,
    fetchWorkerPermissions: PropTypes.func,
    deletePaymentPermissions: PropTypes.func,
    onEdit: PropTypes.bool
    
};

const mapStateToProps = (state, ownProps) => {
    const { workers } = state.budgetsApp;
    const worker = workers.find(worker => worker.userId === ownProps.match.params.workerId);

    const onEdit = state.editor.type === 'paymentPermission';

    return { worker, workers, onEdit };
};

export default connect(mapStateToProps, { setEditedEntity, confirmDelete, fetchWorkerPermissions, deletePaymentPermissions })(WorkerDetails);
